import React from 'react';

import { Card, Large, ContentSubtitle, Button } from 'components';
import { useNavigate } from 'react-router-dom';
import {
  updateUserTypeField,
  clearUserInfoFields,
} from 'redux/slices/signUp/signUpSlice';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

const AddUser = ({ onPrev }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className={`flex flex-col justify-between h-70vh border rounded-md border-default-border w-full sm:w-96`}
    >
      <Card className="flex bg-white flex-col justify-center mx-auto w-full h-full rounded-md shadow-2xl p-0 border-none ">
        <div className="flex flex-row w-full p-6 h-auto items-center  text-center justify-center gap-x-4">
          <Card
            className="bg-primary border-white h-32 cursor-pointer items-center justify-center text-center space-y-2"
            onClick={() => {
              dispatch(clearUserInfoFields());
              dispatch(updateUserTypeField('şahıs'));
              navigate('/create-user/sahis');
            }}
          >
            <i className="fa-solid fa-circle-user text-white" />
            <Large variant="white" weight="semibold">
              Şahıs Hesabı Oluştur
            </Large>
          </Card>
          <Card
            className="bg-primary border-white h-32 cursor-pointer items-center justify-center text-center space-y-2"
            onClick={() => {
              dispatch(clearUserInfoFields());
              dispatch(updateUserTypeField('işletme'));
              navigate('/create-user/isletme');
            }}
          >
            <i className="fa-solid fa-briefcase text-white" />
            <Large variant="white" weight="semibold">
              İşletme Hesabı Oluştur
            </Large>
          </Card>
        </div>
        <ContentSubtitle className="mx-auto">
          Şahıs veya İşletme olarak kolayca kayıt olabilirsiniz.
        </ContentSubtitle>
      </Card>

      {onPrev && (
        <Button
          text="Geri"
          className="bg-ink p-3 mx-auto w-1/3"
          textVariant="white"
          onClick={onPrev}
        />
      )}
    </div>
  );
};

AddUser.propTypes = {
  onPrev: PropTypes.func,
};
export default AddUser;
